var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"logo-container"},[_c('IconLogo',{staticClass:"logo-img"}),_c('p',[_vm._v("Логотип")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }